const StyleVariables = {

  colors: {
    light: '#fff',
    subtleLight: 'rgba(255,255,255,.5)',
    subtleLightMarketing: 'rgba(255,255,255,.8)',
    dark: '#333',
    grey: '#AFAFAF',
    darkBg: '#151515',
    cta: '#eb8a17',
    subtleGrey: '#DBDBDB',
    error: '#C8695C',
    hover: 'rgba(244, 173, 70, .25)',
    lightOrange: '#F4AD46',
    darkOrange: '#C45E00',
    darkerGray: '#3d3d3d',
    darkGray: '#908d90'
  },

  grid: 8,

  playerHeight: 540,
  playerWidth: 960,

	vEndSpacing: 50,
	vEndSpacingXS: 20,

  title: {
    fontWeight: '700',
    fontSize: 40,
    lineHeight: '1.25em',
    letterSpacing: .2,
  },

  smallTitle: {
    fontWeight: '700',
    fontSize: 30,
    lineHeight: '1.25em',
    letterSpacing: .2,
  },

  h1: {
    fontWeight: '700',
    fontSize: 24,
    lineHeight: '1.25em',
    letterSpacing: .2,
  },

  h2: {
    fontWeight: '700',
    fontSize: 22,
    lineHeight: '1.25em',
    letterSpacing: .2,
  },

  h3: {
    fontWeight: '700',
    fontSize: 18,
    lineHeight: '1.25em',
    letterSpacing: .2,
  },

  h4: {
    fontWeight: '700',
    fontSize: 14,
    lineHeight: '1.25em',
    letterSpacing: .2,
  },

  label: {
    fontSize: 12,
    lineHeight: '1.25em',
    textTransform: 'uppercase',
    letterSpacing: .5,
  },

  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },

  flexColumn: {
    display: 'flex',
    flexDirection: 'column'
  },

  flexCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },

  box: {
    boxSizing: 'border-box'
  },

  buttonBase: {
    minHeight: 48,
    padding: '5px 16px',
    fontSize: 16,
    fontWeight: 400,
    transition: 'all .2s ease-out',
    cursor: 'pointer',
    width: 'fit-content',
    borderRadius: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',
    textAlign: 'center'
  }
};

export default StyleVariables
